import { EventParticipant } from 'src/modules/event/models/eventParticipant';
import { EventParticipantRequest } from 'src/modules/event/models/eventParticipantRequest';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'EventParticipant';

export const getAllEventParticipants = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<EventParticipant>>(endpoint);
};

export const getEventParticipantById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<EventParticipant>(endpoint);
};

export const createEventParticipant = (data: EventParticipantRequest) => {
  return AxiosInstance.post(controller, data);
};

export const updateEventParticipant = (data: EventParticipantRequest) => {
  return AxiosInstance.put<EventParticipant>(controller, data);
};

export const deleteEventParticipantById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};

export const deleteEventParticipantList = (ids) => {
  const endpoint = `${controller}/DeleteList`;
  return AxiosInstance.delete(endpoint, { data: ids });
};
